import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  ElementRef,
  AfterViewInit,
  Inject,
  HostBinding,
  Renderer2
} from '@angular/core';

import { trigger, state, style, transition, animate } from "@angular/animations";
import { PublisherService } from './core/services/publisher.service';
import { ChatSession } from './shared/models/chat.model';
import {
  Participant,
  Attributes,
  StartChatRequest,
  QueueQueryRequest
} from './shared/models/chat-api-requests';
import { ChatService } from './modules/chat/chat.service';
import {
  StartChatResponse,
  PollChatResponse,
  ExitChatResponse,
  QueueQueryResponse,
  PartyInfoResponse
} from './shared/models/chat-api-responses';
import { AuthService } from './core/services/auth.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { OverlayContainer } from 'ngx-toastr';
import {
  OrderRoutes,
  RoutePrefix,
  ChatRoutes,
  ProductRoutes,
  OktaRoutes,
  UserRoutes,
  AEMRoutes
} from './core/constants/routes.constant';
import {
  AppMessages,
  Regex,
  UserProperty,
  CacheConstant,
  ChatGroups
} from './core/constants/app.constant';
import { UserService } from './core/services/user.service';
import { AppUtilService } from './core/utils/app-util.service';
import { OktaAuthService } from './core/services/okta-auth.service';
import { LoginDialogComponent } from './modules/okta/login-dialog/login-dialog.component';
import { BaseComponent } from './app.base.component';
import { OrderService } from './modules/order/order.service';
import {
  AppConfigService,
  Configuration
} from './core/services/init/app-config.service';
import { HttpError } from './shared/models/http-error';
import { DOCUMENT } from '@angular/common';
import { ScriptService } from './core/services/script.service';
import { Script } from './shared/models/app';
import { DeviceDetectorService } from 'ngx-device-detector';

import { Title, Meta }     from '@angular/platform-browser';
import { AppRouteHandlerService } from './core/services/route/app-route-handler.service';
import { AppCacheService } from './core/services/cache/app-cache.service';
import { SanitizerService } from './core/services/sanitizer.service';
import { UserApi } from './core/api/user-api';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CMSPages } from './core/constants/app.constant'; 
import { CmsService } from './core/services/cms.service';
import { CmsContent,CmsContentField } from './shared/models/cms';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';
import { Router } from '@angular/router';
declare var window: any;
declare var gtag;

@Component({
  selector: 'par-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('animateChatAlert', [
      state('show', style({ opacity: 1 })),
      state('hide', style({ opacity: 0 })),
      transition('show => hide', animate('1000ms ease-out')),
      transition('hide => show', animate('1000ms ease-in'))
    ])
  ]
})
export class AppComponent extends BaseComponent
  implements OnInit, AfterViewInit {
  /***************Properties***************/
  private chatWindow;
  private pollingInterval: any;
  private currentChatSession: ChatSession = new ChatSession();
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;
  isSearchAllowedOnCreditBlock: boolean = this.cache.get(CacheConstant.Env_Properties).allowSearchOnCreditBlock;
  
  @HostBinding('class') componentCssClass;  

  routes = {
    home: '/',
    forgotPassword: OktaRoutes.ForgotPassword,
    changePassword: OktaRoutes.ChangePassword,
    shoppingCart: OrderRoutes.ShoppingCart,
    basicSearch: ProductRoutes.BasicSearch,
    changeAccount: UserRoutes.ChangeAccount,
    orderHistory: OrderRoutes.OrderHistory,
    shop: AEMRoutes.Shop,
    majorAboutUs: AEMRoutes.MajorAboutUS,
    contactUs: RoutePrefix.ContactUs,
    productCatalogList:AEMRoutes.Major.ProductCatalogList,
    productCatalog: AEMRoutes.Major.ProductCatlog,
    news: AEMRoutes.Major.News,
    register: RoutePrefix.Register,
    packageInsert: RoutePrefix.PackageInsert,
    majorAmazon:RoutePrefix.Amazon
  };
  contentArr: any[];
  ctaPageName: any;
  ctaTemplateNum: any;
  callToActionArrays: any;
  buId = this.envProperties.buId;
  obj:any = {};
  isLoading: boolean;
  isUnderMaintenance: boolean;
  isAuthenticated: boolean;
  isHome = true;
  isExcludePages: boolean;
  isProducts:boolean;
  searchValue = null;
  isProductSearch = false;
  isShoppingCart = false;
  showCheckOut = false;
  isProductDetailsFromSearch = {
    showButton: false,
    previousRoute: ''
  };
  orderCount = -1;
  pageBannerHeader: string;
  exportToExcel: string;
  pageBannerContent: string;
  repInitialMessage: string;
  repName: string;
  orderAccess = {
    showDeniedMessage: false,
    deniedMessage: AppMessages.OrderDeniedMessage,
    mobileDeniedMessage: AppMessages.MobileOrderDeniedMessage,
  };
  customerAssociation = {
    showAssociationMessage: false,
    parmedAssociationMessage: AppMessages.AssociationMessage,
    parmedMobileAssociationMessage: AppMessages.MobileAssociationMessage,
    majorAssociationMessage: AppMessages.MajorAssociationMessage,
    majorMobileAssociationMessage: AppMessages.MajorMobileAssociationMessage
  }
  chat = {
    validateChatTimeout: null,
    pollingInterval: null,
    available: false,
    enable: false,
    initiated: false,
    repInitiated: false,
    showAlert: false,
    activeMessage: 'Chat with us',
    inactiveMessage: 'Chat is unavailable'
  };

  userAuthDetails: any;
  expertMedFlag : boolean = false;
  userInfo = {
    firstName: null,
    lastName: null,
    accountName: null
  };

  isApp: boolean = AppUtilService.isMobileApp();

  get currentAlertState() {
    return this.chat.showAlert ? 'show' : 'hide';
  }

  get currentIconState() {
    return !this.chat.showAlert ? 'show' : 'hide';
  }
  errorMsg='';
  showMobileMenu = false;
  /***************Properties***************/

  /***************Constructor***************/

  constructor(
    private cache: AppCacheService,
    private appRouteHandlerService: AppRouteHandlerService,
    private cdr: ChangeDetectorRef,
    private configService: AppConfigService,
    private oktaAuthService: OktaAuthService,
    private authService: AuthService,
    private userService: UserService,
    private orderService: OrderService,
    private chatService: ChatService,
    private loader: LoadingBarService,
    private script: ScriptService,
    private overlayContainer: OverlayContainer,
    public dialog: MatDialog,
    private deviceService: DeviceDetectorService,
    private titleService: Title,
    private metaService: Meta,
    private renderer2: Renderer2,
    private sanitizerService: SanitizerService,
    private dialogRef: MatDialog,
    private router: Router,
    private cmsService: CmsService,
    private sanitizer: DomSanitizer,
    @Inject(DOCUMENT) private document: any
  ) {
    super(deviceService, cache , configService);
  } 

  ngOnInit() {
    this.getCTAContent();
    if (this.configService.gTrackingId) {
      const s = this.renderer2.createElement('script');
      s.src = "https://www.googletagmanager.com/gtag/js?id=" + this.configService.gTrackingId;
      s.text = ``;
      s.async = true;
      this.renderer2.appendChild(this.document.head, s);

     
      const s2 = this.renderer2.createElement('script');
      var code = "window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); } gtag('js', new Date());";
      s2.appendChild(document.createTextNode(code));

      this.renderer2.appendChild(this.document.head, s2);
    }

    
    const containerId = this.configService.gtmContainerId;
    if (containerId) {
      const s = this.renderer2.createElement('script');
      var code = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" + containerId + "');";
      s.async = true;
      this.renderer2.appendChild(this.document.head, s);

      const s2 = this.renderer2.createElement('script');
      s2.appendChild(document.createTextNode(code));
      this.renderer2.appendChild(this.document.head, s2);
   }

   this.metaService.addTags([
    {name: 'keywords', content: this.configService.webSEOKeywords},
    {name: 'description', content: this.configService.webSEODescription},
    {name: 'robots', content: this.configService.webSEORobots}
  ]);
  
  
    this.appRouteHandlerService.isAppDown.subscribe(res=> this.isUnderMaintenance = res && window.location.origin.toString().startsWith(this.envProperties.appDownUrl));
    // this.overlayContainer.getContainerElement().classList.add(this.websiteName);
    this.componentCssClass = this.websiteName;

    if(this.websiteName == 'Parmed') {
      this.setTitle('ParMed');
    } else if(this.websiteName == 'Major') {
      this.setTitle('Major Rugby');
    }

    this.isUnderMaintenance =
      this.configService.get(Configuration.UNDER_MAITENANCE).toBoolean() &&
      window.location.origin.toString().startsWith(this.envProperties.appDownUrl);

    if (!this.isUnderMaintenance) {
      this.loadExternalLibraries(this.envProperties.externalLibrabries);
      this.oktaAuthService.init();
      this.isAuthenticated = this.authService.isAuthenticated();
      this.getUserInfo();
    
      this.validateCanOrderAvailability();  
      this.validateIsAssociationExists();

      AppUtilService.router.events.subscribe((event: any) => {
        this.onRouterEventChage(event);
      });

      PublisherService.signInRequest$.subscribe(data => {
        this.signIn(data);
      });

      PublisherService.signOutRequest$.subscribe(request => {
        this.signOut();
      });

      PublisherService.isAuthChanged$.subscribe(isAuth => {
        this.onAuthenticationChange(isAuth);
      });

      PublisherService.isAccountChanged$.subscribe(accountChanged => {
        this.onAccountChange(accountChanged);
      });

      PublisherService.cartCountUpdated$.subscribe(count =>
        this.onCartCountUpdate(count)
      );

      this.loader.progress$.subscribe(progress => {
        this.onLoadingProgressChange(progress);
      });

      PublisherService.bannerHeaderChangedSource$.subscribe(bannerHeader => {
        this.pageBannerHeader = bannerHeader;
        this.cdr.detectChanges();
      });

      PublisherService.exportToExcel$.subscribe(product => {
        this.exportToExcel = product;
        this.cdr.detectChanges();
      });

      PublisherService.bannerContentChangedSource$.subscribe(bannerContent => {
        this.pageBannerContent = bannerContent;
        this.cdr.detectChanges();
      });

      PublisherService.loadUserInfo$.subscribe(userId => {
        this.getUserDetails();
        this.loader.complete();
        AppUtilService.redirectToHome();
      });
    }
  }

  public setTitle( newTitle: string) {
    this.titleService.setTitle( newTitle );
  }
  onSignInClick(): void {
    PublisherService.notifySignInRequest(null);
  }
  
  ngAfterViewInit() {
    if (!this.isUnderMaintenance) {
      setTimeout(() => {
        this.adjustMainContainerHeight();
      }, 500);

      if (this.isAuthenticated) {
        this.getOrderCount();
      }

      setTimeout(() => {
        this.getStaticData();
      }, 0);
    }
  }

  /***************Constructor***************/

  /******************Component Methods******************/

  onLogInClick() {
    this.signIn(null);
  }

  onNavigationClick(route) {
    AppUtilService.router.navigate([route]);
  }

  onSearchChange() {
    if (this.searchValue) {
      setTimeout(() => {
        this.searchValue = this.searchValue.replace(
          Regex.RestrictSpecialChars,
          ''
        );
      }, 50);
    }
  }

  onSearchProductsSubmit() {
    const searchUrl = ProductRoutes.BasicSearch + '/';
    if(this.searchValue!=null){
      AppUtilService.router.navigate([searchUrl + this.searchValue.encode()]);
    }
    else{
      AppUtilService.router.navigate([searchUrl + this.searchValue]);
    }
   
    PublisherService.notifySearchTrigger({
      searchVal: this.searchValue,
      advSearchType: null,
      advSearchFilter: null
    });
    this.searchValue = '';
    this.document.getElementById('searchvalue').blur();
  }

  onToggleChatAlert(e: string) {
    this.chat.showAlert = !this.chat.showAlert;
    switch (e) {
      case 'yes':
        this.initRepChat();
        break;
      case 'no':
        this.exitChat();
        break;
      default:
        break;
    }
  }

  onInitiateChatClick() {
    if (this.chat.enable && this.chat.available && !this.chat.initiated) {
      const wdth = 400;
      const hgth = 665;
      const lft = window.innerWidth - wdth - 50;
      const tp = window.innerHeight - hgth;
      if (this.chatWindow == null || this.chatWindow.closed) {
        this.chatWindow = window.open(
          RoutePrefix.Chat,
          '_blank',
          'directories=1,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no' +
          'top=' +
          tp +
          ',left=' +
          lft +
          ' ,width=' +
          wdth +
          ',height=' +
          hgth,
          true
        );
      } else {
        this.chatWindow.focus();
      }
    }
  }

  onCheckoutClick() {
    AppUtilService.router.navigate([OrderRoutes.ShoppingCart]);
  }

  onSignOutClick() {
    this.signOut();
  }

  onAppDownload(platform) {
    if (platform === 'apple') {
      window.open('https://itunes.apple.com/us/app/parmed-pharmaceuticals/id1436168958?mt=8', '_self');
    } else if (platform === 'google') {
      window.open('https://play.google.com/store/apps/details?id=app.ParMed', '_self');
    }
  }

  /******************Component Methods******************/

  /******************Private Methods******************/

  private getOrderCount() {
    if (this.isAuthenticated) {
      this.orderService.cartCountUpdate();
    }
  }

  private onRouterEventChage(event): any {
    if (event.toString().startsWith('NavigationStart')) {
      if (event.url.startsWith('/chat')) {
        this.chat.initiated = true;
        this.chat.repInitiated = true;
      }

      if(AppUtilService.router.url !== event.url) {
        this.pageBannerHeader = '';
        this.pageBannerContent = '';
        this.exportToExcel='';
      }
    }

    if (event.toString().startsWith('NavigationEnd')) {

      if (this.configService.gTrackingId) {
        gtag('config', this.configService.gTrackingId);
      }
      
      setTimeout(() => {
        this.adjustMainContainerHeight();
      }, 500);
      this.isHome = (event.url === '/' || event.url === '/home' || event.url === '/myhome');
      this.isExcludePages=(event.url==='/major-about-us' || event.url==='/product-catalog-list' || event.url==='/major-amazon' ||event.url==='/major-news'||
        event.url==='/contact-us' || event.url==='/package-insert' || event.url==='/majorPrivacy' || event.url ==='/majorLegal' || event.url =='/register' || event.url=='/major-welcome')
        this.isProducts=event.url==='/product-catalog-list'
      this.validateCanOrderAvailability();
      this.validateIsAssociationExists();
      this.adjustMainContainerHeight();

      if (!this.chat.initiated) {
      //  this.validateChatAvailability();
      }
      this.getExpertMedFlag()
      this.isProductSearch =
        event.url.startsWith('/' + ProductRoutes.BasicSearch) ||
        event.url.startsWith('/' + ProductRoutes.AdvanceSearch);

      this.isShoppingCart = event.url.startsWith(
        '/' + OrderRoutes.ShoppingCart
      );

      this.showCheckOut =
        this.isProductSearch ||
        event.url.startsWith('/' + ProductRoutes.Favorites) ||
        event.url.startsWith('/' + ProductRoutes.Substitutes) ||
        event.url.startsWith('/' + ProductRoutes.WatchList) ||
        event.url.startsWith('/' + ProductRoutes.Promotions_Detail) ||
        event.url.startsWith('/' + ProductRoutes.Category_Detail);

      if (event.url.includes('/' + ProductRoutes.Detail)) {
        const previousUrl = AppUtilService.cache.get(
          CacheConstant.Search_Route
        );
        if (previousUrl) {
          this.isProductDetailsFromSearch.showButton = true;
          this.isProductDetailsFromSearch.previousRoute = previousUrl;
          AppUtilService.cache.set(CacheConstant.Search_Route, '');
        } else {
          this.isProductDetailsFromSearch.showButton = false;
        }
      } else {
        this.isProductDetailsFromSearch.showButton = false;
      }
    }
  }

  private getExpertMedFlag() {
    this.userAuthDetails = this.cache.get(CacheConstant.User_Auth_Detail);
    this.expertMedFlag = (this.userAuthDetails != undefined) ? this.userAuthDetails.expertMedFlg : false;
  }

  private signIn(data: any) {
    this.dialog
      .open(LoginDialogComponent, { width: '400px', data: data })
      .afterClosed()
      .subscribe(response => {
        if (!response) {
          this.isAuthenticated = false;
          return;
        }
        if (data) {
          AppUtilService.cache.set(CacheConstant.CallBackUrl, data.callBackUrl)
        }
        const isAuthenticated = response && !response.hasError;

        if (!isAuthenticated) {
          AppUtilService.message.error(AppMessages.GenericErrorMessage);
        } else {
          if (data == null) {
            if (response.status === 'PASSWORD_EXPIRED') {
              this.loader.complete();
              AppUtilService.router.navigate([OktaRoutes.ChangePassword]);
            } else {
              this.getUserDetails();
            }
          } else {
            this.loader.complete();
            this.getUserDetails();
          }
        }
      });
  }

  private getUserDetails() {
    this.oktaAuthService.getUserSession().subscribe((response: any) => {
      if (!response.hasError) {
        AppUtilService.cache.set(CacheConstant.Okta_Session_Id, response.id);

        this.authService.authenticate().subscribe((authResponse: any) => {
          this.userService.get().subscribe((detailResponse: any) => {
            if (!detailResponse.hasError) {
              detailResponse.userDetail.defaultShipToNumber = detailResponse.defaultShipToNumber;
              detailResponse.userDetail.defaultSoldToNumber = detailResponse.defaultSoldToNumber;
              detailResponse.userDetail.accounts = detailResponse.accounts;
              detailResponse.userDetail.secondLastLogin = detailResponse.userDetail.secondLastLogin;
              detailResponse.userDetail.oktaRecoveryQuestions =
                detailResponse.oktaRecoveryQuestions;
              AppUtilService.cache.set(
                CacheConstant.User_Auth_Detail,
                detailResponse.userDetail
              );
              AppUtilService.cache.set(
                CacheConstant.Is_Credit_Available,
                detailResponse.isCreditAvailable
              );
              AppUtilService.cache.set(CacheConstant.Pwd_Dtl,
                detailResponse.passwordDetails
              );
              AppUtilService.cache.set(CacheConstant.SalePopUp,
                detailResponse.showPromotionItemPopup
              );
              this.loader.complete();
              PublisherService.notifyAuth(true);
            } else {
              const error = authResponse as HttpError;
              const sanitizedMessage = this.sanitizerService.sanitizeHtml(
                AppUtilService.resolveErrorResponse(error).messageText
              );
              AppUtilService.message.error(sanitizedMessage);
            }
          });
        });
      }
    });
  }

  private signOut() {

    this.dialogRef.closeAll();
    this.authService.signOut().subscribe((res: any) => {
      if (!this.isMobileDevice()) {
        AppUtilService.redirectToHome();
      } else {
        AppUtilService.redirectToHomeMobile();
      }
    });
  }

  private onAuthenticationChange(isAuthenticated): any {
    this.isAuthenticated = isAuthenticated;
    this.validateCanOrderAvailability();
    this.validateIsAssociationExists();
    this.getUserInfo();
    this.adjustMainContainerHeight();

    if (!this.isAuthenticated) {
      this.userInfo = {
        firstName: null,
        lastName: null,
        accountName: null
      };

      PublisherService.notifyCartCountUpdated(0);
      this.chat.showAlert = false;
      this.currentChatSession = new ChatSession();
      this.repName = '';
      this.repInitialMessage = '';

      if (
        (this.chatWindow == null || this.chatWindow.closed) &&
        this.chat.repInitiated
      ) {
        clearInterval(this.pollingInterval);
        this.exitChat();
      }
    } else {
      this.getOrderCount();
    }

    this.isMobileDevice()
      ? AppUtilService.redirectToHomeMobile()
      : AppUtilService.redirectToHome();
  }

  private validateCanOrderAvailability() {
    this.orderAccess.showDeniedMessage = false;
    const isCustomerAsscociationExists = this.userService.isAssociationExists();
    const canOrder = this.userService.canOrder();
    if (this.isAuthenticated) {
      const UserCustomerRef = isCustomerAsscociationExists?.userCustomerXrefs;
        if (this.websiteName == "Parmed" && UserCustomerRef.length != 0 && !canOrder && !this.isSearchAllowedOnCreditBlock) {
          this.orderAccess.showDeniedMessage = true;
        }
        if ((this.websiteName == "Major" && UserCustomerRef.length != 0) && (!this.userService.canOrderMajor() || !this.userService.canPayInvoice() || !this.userService.accessDSCSA())) {
          this.orderAccess.showDeniedMessage = true;
          this.getMessages();
        }
    }
  }

  private validateIsAssociationExists(){
    this.customerAssociation.showAssociationMessage = false;
    const isCustomerAsscociationExists = this.userService.isAssociationExists();
    if (this.isAuthenticated) {
      const UserCustomerRef = isCustomerAsscociationExists?.userCustomerXrefs;
      if (UserCustomerRef.length === 0) {
        this.customerAssociation.showAssociationMessage = true;
      }
    }
  }

  private validateChatAvailability() {
    if (!this.chat.validateChatTimeout && this.isAuthenticated && this.websiteName !="Major") {
      this.chat.validateChatTimeout = setTimeout(() => {
        this.chat.validateChatTimeout = null;
        if (this.isDesktopDevice()) {
          const _participant: Participant = {
            name: 'SystemUser',
            credentials: ''
          };

          const queueQueryRequest: QueueQueryRequest = {
            queueName: ChatGroups.CUSTOMER_CARE,
            queueType: 'Workgroup',
            participant: _participant
          };
          this.chatService.queueQuery(queueQueryRequest).subscribe((res: any) => {
            const queue =
            res.status === 200 ? JSON.parse(res.responseText).queue : null;

          if (queue != null) {
            const availableAgents = queue.estimatedWaitTime;
            this.chat.enable = availableAgents >= 0;
          }
          const defaultAccount = this.userService.getDefaultAccSoldtoShipToObj();

          let data = { shipTO: '', buId: this.envProperties.buId };
          if (this.isAuthenticated) {
            // data = { shipTO: defaultAccount.shipToNum.toString() };
            if (defaultAccount.shipToNum) {
              data = { shipTO: defaultAccount.shipToNum.toString(), buId: this.envProperties.buId };
            } else {
              data = { shipTO: '', buId: this.envProperties.buId };
            }
          }

          this.chatService
            .getGlobalSettings(data)
            .subscribe((settings: any) => {
              this.chat.available = settings && settings.chatEnabledFlag;

              if (this.isAuthenticated) {
                const userDetail = AppUtilService.cache.get(
                  CacheConstant.User_Auth_Detail
                );
                this.chat.available =
                  settings &&
                  settings.chatEnabledFlag &&
                  settings.customerChatEnabledFlag;

                this.userService
                  .getLastRepInitChatTime(userDetail.userDetailNum)
                  .subscribe((lastRepInitRes: any) => {
                    if (lastRepInitRes && !lastRepInitRes.hasErrors) {
                      const currentDate = new Date();
                      const validRepInitTime = Date.UTC(
                        currentDate.getUTCFullYear(),
                        currentDate.getUTCMonth(),
                        currentDate.getUTCDate(),
                        currentDate.getUTCHours() -
                        this.envProperties.repInitChatIntervalHours,
                        currentDate.getUTCMinutes(),
                        currentDate.getUTCSeconds()
                      );
                      const validRepInitDate = new Date(validRepInitTime);

                      if (lastRepInitRes.lastRepInitTim === '') {
                        lastRepInitRes.lastRepInitTim = validRepInitDate;
                      }
                      const lastRepInitTim = new Date(
                        lastRepInitRes.lastRepInitTim
                      );

                      if (validRepInitDate >= lastRepInitTim) {
                        // console.log(this.chat);
                        if (
                          settings.chatEnabledFlag &&
                          settings.chatRepInitEnabledFlag &&
                          !this.chat.initiated &&
                          !this.chat.repInitiated
                        ) {
                          this.startChat(userDetail, defaultAccount);
                        }
                      }
                    }
                  });
              }
            });
          });
        }
      }, 3000);
    }
  }

  private initRepChat() {
    if (this.currentChatSession && this.currentChatSession.chatID) {
      clearInterval(this.pollingInterval);
      if (this.chatWindow == null || this.chatWindow.closed) {
        const width = 400;
        const height = 665;
        const left = window.innerWidth - width - 50;
        const top = window.innerHeight - height;
        this.chatWindow = window.open(
          ChatRoutes.StartChat +
          ';chatID=' +
          this.currentChatSession.chatID +
          ';repname=' +
          this.repName +
          ';message=' +
          this.repInitialMessage,
          'Parmed Chat',
          'directories=1,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no' +
          'top=' +
          top +
          ',left=' +
          left +
          ' ,width=' +
          width +
          ',height=' +
          height,
          true
        );
      } else {
        this.chatWindow.focus();
      }
    }
  }

  private startChat(userDetail: any, defaultAccount: any) {
    const _participant: Participant = {
      name: userDetail.firstName + ' ' + userDetail.lastName,
      credentials: ''
    };

    let phone = '';
    let account = '';

    if (userDetail.phoneNum) {
      phone = userDetail.phoneNum.toString();
    }
    if (defaultAccount.shipToNum) {
      account = defaultAccount.shipToNum.toString();
    }

    const _attributes: Attributes = {
      phone: phone,
      accountnumber: account,
      repInitiatedChat: 'true'
    };

    const startChatRequest: StartChatRequest = {
      supportedContentTypes: 'text/plain',
      participant: _participant,
      transcriptRequired: false,
      emailAddress: userDetail.emailAddress,
      target: ChatGroups.REP_INITIATED,
      targettype: 'Workgroup',
      language: 'en-us',
      clientToken: 'deprecated',
      attributes: _attributes
    };

    this.chatService.startChatRequest = startChatRequest;
    this.chatService.start().subscribe((response: any) => {
      let startChatResponse: StartChatResponse;
      startChatResponse = response.chat;
      if (
        startChatResponse &&
        startChatResponse.status.type.toLowerCase() === 'success'
      ) {
        this.userService
          .updateLastRepInitChatTime(userDetail.userDetailNum)
          .subscribe();
        this.currentChatSession.chatID = startChatResponse.chatID;
        this.currentChatSession.userParticipantID =
          startChatResponse.participantID;
        this.chat.repInitiated = true;
        this.pollingInterval = setInterval(() => {
          this.pollChat();
        }, 2000);
      }
    });
  }

  private pollChat() {
    if (this.currentChatSession && this.currentChatSession.userParticipantID) {
      const ajaxResponse = this.chatService.poll(
        this.currentChatSession.userParticipantID
      );
      let pollChatResponse: PollChatResponse;
      pollChatResponse = JSON.parse(ajaxResponse.responseText).chat;
      if (pollChatResponse && pollChatResponse.events) {
        this.currentChatSession = this.chatService.handleEvents(
          pollChatResponse.events,
          this.currentChatSession
        );
        if (
          this.repInitialMessage === undefined ||
          this.repInitialMessage === ''
        ) {
          this.repInitialMessage = this.currentChatSession.lastRepChatMessage;
          this.currentChatSession.lastRepChatMessage = '';
        } else {
          // clearInterval(this.pollingInterval);
          this.repName = this.currentChatSession.repDisplayName;
          this.chat.showAlert = this.currentChatSession.showRepInitAlert;
        }

        if (this.currentChatSession.repParticipantID !== undefined) {
          if (
            this.currentChatSession.repImageURL === undefined ||
            this.currentChatSession.repImageURL ===
            '/assets/images/rep-chat-person-default.png'
          ) {
            this.chatService
              .getPartyInfo(
                this.currentChatSession.userParticipantID,
                this.currentChatSession.repParticipantID
              )
              .subscribe((res: any) => {
                const partyInfoResponse: PartyInfoResponse = res.partyInfo;
                this.currentChatSession.repImageURL =
                  partyInfoResponse != null && partyInfoResponse.photo != null
                    ? this.envProperties.chatApiUrl + partyInfoResponse.photo
                    : '/assets/images/rep-chat-person-default.png';
              });
          }
        }

        if (this.currentChatSession.isDisconnectEventReceived) {
          this.chat.showAlert = false;
          this.chat.repInitiated = false;
          clearInterval(this.pollingInterval);
        }
      }
    }
  }

  private exitChat() {
    if (this.currentChatSession && this.currentChatSession.userParticipantID) {
      this.chatService
        .exit(this.currentChatSession.userParticipantID)
        .subscribe((response: any) => {
          let exitChatResponse: ExitChatResponse;
          exitChatResponse = response.chat;
          if (exitChatResponse.status.type === 'success') {
            this.chat.showAlert = false;
          }
        });
    }
  }

  private getStaticData() {
    this.configService.getStaticData().subscribe();
  }

  private onAccountChange(accountChanged: any) {
    if (accountChanged) {
      AppUtilService.cache.set(
        CacheConstant.Is_Credit_Available,
        accountChanged.isCreditAvailable
      );
      if (!accountChanged.isCreditAvailable && !this.isSearchAllowedOnCreditBlock) {
        this.orderAccess.showDeniedMessage = true;
      }
      this.getOrderCount();
      this.getUserInfo();
    }
  }

  private setMajorActiveAccountHeight() {
    if (!this.isMobileDevice()) {
      if (this.websiteName === 'Major') {
        const majorSelector = this.document.getElementById('active-major');
        const rugbySelector = this.document.getElementById('active-rugby');
        const headerSelector = this.document.getElementById('parmed-header');
        const headerHeight = headerSelector ? headerSelector.clientHeight : 0;
  
        const division = this.userService.getDefaultAccountMasterData().division;
        if (division === 'Major') {
          majorSelector.style.minHeight = (headerHeight - 7) + 'px';
        } else {
          rugbySelector.style.minHeight = (headerHeight - 7) + 'px';
        }
      }
    }
  }

  private onCartCountUpdate(orderCount: any) {
    this.orderCount = orderCount;
  }

  private onLoadingProgressChange(progress: number) {
    this.isLoading = progress > 0 && progress < 200;
    const containerClassList = this.overlayContainer.getContainerElement()
      .classList;
    this.isLoading
      ? containerClassList.add('parmed-loading')
      : containerClassList.remove('parmed-loading');
  }

  private getUserInfo() {
    if (this.isAuthenticated) {
      const defaultAccount = this.userService.getDefaultAccountMasterData();
      this.userInfo = {
        firstName: this.userService.getProperty(UserProperty.FirstName),
        lastName: this.userService.getProperty(UserProperty.LastName),
        accountName: defaultAccount ? defaultAccount.name : 'Not Available'
      };
    } else {
      this.userInfo = {
        firstName: null,
        lastName: null,
        accountName: null
      };
    }
  }

  private loadExternalLibraries(libraries: string[]) {
    const scripts: Script[] = [];
    libraries.forEach(src => {
      scripts.push({
        src: src,
        loaded: false
      });
    });
    this.script.loadMultiple(scripts);
  }

  private adjustMainContainerHeight(): any {
    /*
      * Set main container height by substracting header, navbar, footer height from document inner height.
      * This will be used to set footer at the bottom of page.
      * */
    const extraMargin = !this.isMobileDevice() ? 5 : 2;
    const mainSelector = this.document.getElementById('main-content-wrapper');
    const headerSelector = this.document.getElementById('parmed-header');
    const navbarSelector = this.document.getElementById('parmed-navbar');
    const footerSelector = this.document.getElementById('parmed-footer');

    const headerHeight = headerSelector ? headerSelector.clientHeight : 0;
    const navbarHeight = navbarSelector ? navbarSelector.clientHeight : 0;
    const footerHeight = footerSelector ? footerSelector.clientHeight : 0;

    if (mainSelector) {
      mainSelector.style.minHeight =
        this.document.documentElement.clientHeight -
        (headerHeight + navbarHeight + footerHeight + extraMargin) +
        'px';
    }

    // this.setMajorActiveAccountHeight();
    /*
    * Set main container height by substracting header, navbar, footer height from document inner height.
    * This will be used to set footer at the bottom of page.
    * */
  }

  getMessages() {
    if (this.userService.canOrderMajor() && this.userService.canPayInvoice() && this.userService.accessDSCSA()) {
      this.errorMsg = '';
      return false;
    }

    if (this.userService.canOrderMajor() && this.userService.canPayInvoice()) {
      this.errorMsg = AppMessages.MajorOrderAndPayEnableMessage;
      return true;
    }

    else if ( this.userService.canOrderMajor() && this.userService.accessDSCSA()) {
      this.errorMsg = AppMessages.MajorOrderAndDscsaEnableMessage;
      return true;
    }

    else if (this.userService.canPayInvoice() && this.userService.accessDSCSA()) {
      this.errorMsg = AppMessages.MajorPayInvoiceAndDscsaEnableMessage;
      return true;
    }

    else if (this.userService.canOrderMajor()) {
      this.errorMsg = AppMessages.MajorOrderEnableMessage;
      return true;
    }

    else if (this.userService.canPayInvoice()) {
      this.errorMsg = AppMessages.MajorPayInvoiceEnableMessage;
      return true;
    }
    else if (this.userService.accessDSCSA()) {
      this.errorMsg = AppMessages.MajorDscsaEnableMessage;
      return true;
    }
    else if(this.isAuthenticated && (!this.userService.canOrderMajor() && !this.userService.canPayInvoice() && !this.userService.accessDSCSA())){
      this.errorMsg = AppMessages.MajorNoAccessMessage;
      return true;
    }
    else {
      this.errorMsg = '';
      return false;
    }
  }
  getCTAContent() {
    if(this.isMobileDevice() && this.websiteName == 'Major')
      this.ctaPageName = this.isAuthenticated ? CMSPages.Mobile_Home : CMSPages.Mobile_Login;
    else
    this.ctaPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
    this.ctaTemplateNum = this.envProperties.cmsPageConfigVO.ctaTemplateId;
    this.cmsService.getCmsContentByPageNameAndTemplateNum(this.ctaPageName, this.buId, this.ctaTemplateNum).subscribe((response: any) => {
      if (!response.hasError) {
        if (response.length > 0) {
          this.callToActionArrays = response;
          this.contentArr = []
            const sortedAndGroupesCallToActions = _.chain(this.callToActionArrays)
              .orderBy((callToActonObj: CmsContent) => callToActonObj.rowUpdateStamp, ['desc'])
              .groupBy((callToActonObj: CmsContent) => callToActonObj.sequenceNum)
              .value();
            for (const key of Object.keys(sortedAndGroupesCallToActions)) {
              this.contentArr.push(sortedAndGroupesCallToActions[key][0]);
            }
           this.contentArr = this.parseContentStructureField(this.contentArr);
        }
      } 
    });
  }
  private parseContentStructureField(
    callToActionDataArray: CmsContent[]
  ): CmsContent[] {
    if (callToActionDataArray.length > 0) {
      callToActionDataArray = _.orderBy(
        callToActionDataArray,
        [CmsContentField.sequenceNum],
        'asc'
      );
      callToActionDataArray.forEach((cta: CmsContent) => {
        cta.contentStructureJson = JSON.parse(cta.contentStructure);
        cta.contentStructureJson.description = this.sanitizer.bypassSecurityTrustHtml(this.cmsService.processHtmlContentforHashTag(cta.contentStructureJson.description));
        cta.increaseImageHeight =
        cta.contentStructureJson.description !== '' ? false : true;
      });
      return callToActionDataArray;
    }
  }
  onAboutUsClick() {
    this.router.navigate([AEMRoutes[this.websiteName].AboutUs]);
  }
  ctaClick( cmsContentLinkObj: any){
    this.navigateToTargetLink(cmsContentLinkObj);
  }
   navigateToTargetLink(cmsContentLinkObj: any) {
      if (!_.isEmpty(cmsContentLinkObj)) {
        this.cmsService.redirectBasedOnLinkType(cmsContentLinkObj);
      }
    }
  /******************Private Methods******************/
}
